const tabs = document.querySelectorAll('.tabs');

function initTabController() {
  tabs.forEach(tab => {
    const tabButtons = tab.querySelectorAll('.tabs__btn');
    const tabContents = tab.querySelectorAll('.tabs__cont');

    if (!tabButtons.length || !tabContents.length) return;

    function showTab(button) {
      const tabId = button.dataset.tab;

      tabButtons.forEach(btn =>
        btn.classList.remove('is-active', 'is-visible')
      );
      tabContents.forEach(content =>
        content.classList.remove('is-active', 'is-visible')
      );

      button.classList.add('is-active');

      if (tabId === 'all') {
        tabContents.forEach(content => {
          content.classList.add('is-active');
          setTimeout(() => {
            content.classList.add('is-visible');
          }, 150);
        });
        return;
      }

      const targetTab = document.getElementById(tabId);
      if (!targetTab) return;

      targetTab.classList.add('is-active');
      setTimeout(() => {
        targetTab.classList.add('is-visible');
        button.classList.add('is-visible');
      }, 150);
    }

    function handleTabBtns(event) {
      const button = event.currentTarget;
      if (button.classList.contains('is-active')) return;
      showTab(button);
    }

    tabButtons.forEach(button => {
      button.addEventListener('click', handleTabBtns);
    });

    const activeBtn =
      tab.querySelector('.tabs__btn.is-active') || tabButtons[0];
    if (activeBtn) showTab(activeBtn);
  });
}

document.addEventListener('DOMContentLoaded', initTabController);
